import { components as antdComponents } from '@yimoka/antd';
import { EntityResponse, type IConfigComponents } from '@yimoka/react';

import { AgreementCheckbox } from '@/components/AgreementText';
import { BooleanChoice } from '@/components/boolean-choice';
import { AgreementLoginForm } from '@/components/enter/agreement-login-form';
import { ImageCaptcha } from '@/components/enter/captcha-image';
import { PasswordLoginCaptcha } from '@/components/enter/password-login-captcha';
import { PhoneCaptchaButton } from '@/components/enter/phone-captcha-button';
import { PhoneInput } from '@/components/enter/phone-input';
import { StatusToggleAction } from '@/components/status-toggle-action';

import { ErrorContent, Loading, Skeleton } from './runtime-components';

export const components: IConfigComponents = {
  ...antdComponents,
  Loading,
  Skeleton,
  ErrorContent,
  EntityResponse,
  AgreementCheckbox,
  AgreementLoginForm,
  BooleanChoice,
  ImageCaptcha,
  PasswordLoginCaptcha,
  PhoneCaptchaButton,
  PhoneInput,
  StatusToggleAction,
};
